import styled from '@emotion/styled'

export const Cont = styled.div((props) => ({
  display: 'flex',
  marginTop: '1rem',

  '.ui.steps .step': {
    padding: '10px 5px !important',
    width: 'auto !important',
  },

  '.ui.steps>.step>i': {
    display: 'none'
  },

  '.ui.steps': {
    flex: 1,
    flexDirection: 'row',
  },

  '.ui.steps .step:first-child': {
    borderRadius: '5px 0 0 5px'
  },

  '.ui.steps .step:last-child': {
    borderRadius: '0 5px 5px 0'
  },

  '.stepComplete': {
    background: '#7bc142 !important',

    '::after': {
      background: '#7bc142 !important',
    }
  },

  '.stepInprocess': {
    background: '#e9c349 !important',

    '::after': {
      background: '#e9c349 !important',
    }
  },

  '.stepWait': {
    background: '#b9babe !important',

    '::after': {
      background: '#b9babe !important',
    }
  },

  '.stepCancelled': {
    background: '#db2828 !important',

    '::after': {
      background: '#db2828 !important',
    }
  },

  '@media only screen and (min-width: 600px)': {
    '.ui.steps .step': {
      padding: '0.3rem 2em',
    },

    '.ui.steps>.step>i': {
      display: 'block'
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.ui.steps .step': {
      padding: '0.3rem 2em',
    },

    '.ui.steps>.step>i': {
      display: 'block'
    },
  },
}))

export const TimeLineStepCont = styled.div((props) => ({
  '.ui.label > .icon': {
    margin: 0
  },
  '.ui.circular.label': {
    paddting: '0.5833rem 0.833rem'
  }
}))



